export default "__VITE_ASSET__DYJY_kTD__"